import { render, staticRenderFns } from "./KatashikiDialog.vue?vue&type=template&id=4261e5bf&"
import script from "./KatashikiDialog.vue?vue&type=script&lang=ts&"
export * from "./KatashikiDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KatashikiDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports